<template>
  <div class="admin-shell">
    <div v-if="mobileOpen" class="admin-shell__overlay" @click="mobileOpen = false"></div>

    <AdminSidebar
      :active-key="activeMenu"
      :mobile-open="mobileOpen"
      :collapsed="sidebarCollapsed && !isMobileViewport"
      :commercial-id="commercialId"
      @navigate="mobileOpen = false" />

    <div class="admin-shell__main" :class="{ 'is-collapsed': sidebarCollapsed && !isMobileViewport }">
      <header class="admin-shell__topbar">
        <button class="admin-shell__menu-button" type="button" @click="mobileOpen = !mobileOpen">
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div class="admin-shell__collapse-button" @click="toggleSidebar">
          <!-- <span :class="{ 'is-collapsed': sidebarCollapsed }"></span> -->
          <svg v-if="!sidebarCollapsed" t="1777969220000" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="7443" width="200" height="200">
            <path
              d="M914.368 350.336l-519.68 0c-25.152 0-45.568 22.016-45.568 48.896 0 26.88 20.416 48.896 45.568 48.896l519.68 0c25.21599999 0 45.63199999-22.016 45.632-48.896 0-26.88-20.48-48.896-45.632-48.896z m0 228.096l-519.68 0c-25.152 0-45.568 21.95200001-45.568 48.896 0 26.88 20.416 48.896 45.568 48.896l519.68 0c25.21599999 0 45.63199999-22.016 45.632-48.896 0-26.88-20.48-48.896-45.632-48.896z m-3.264 219.904l-795.776 0c-26.88 0-50.56 20.352-51.328 47.168A48.896 48.896 0 0 0 112.89600001 896L908.672 896c26.88 0 50.56-20.416 51.328-47.168a48.896 48.896 0 0 0-48.89600001-50.56z m-619.776-447.232L291.328 675.328 64 513.216l227.328-162.112c0-0.768 0-0.768 0 0z m-178.432-122.944L908.672 228.16c26.88 0 50.56-20.48 51.328-47.232a48.896 48.896 0 0 0-48.89600001-50.496l-795.77599999 0c-26.88 0-50.56 20.416-51.328 47.232a48.896 48.896 0 0 0 48.896 50.496z"
              fill="#000000" p-id="7444"></path>
          </svg>
          <svg v-else t="1777968932017" class="icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="7121" width="200" height="200">
            <path
              d="M109.63199999 673.66399999l519.68000002 1e-8c25.15200001 0 45.568-22.016 45.56799998-48.896 0-26.88-20.41600001-48.896-45.568-48.896l-519.67999998 0c-25.21599999 0-45.63199999 22.016-45.63200001 48.896 0 26.88 20.48 48.896 45.63199999 48.89599999z m2e-8-228.09599999l519.67999998 0c25.15200001 0 45.568-21.95200001 45.56800002-48.896 0-26.88-20.41600001-48.896-45.568-48.896l-519.68000002 1e-8c-25.21599999 0-45.63199999 22.016-45.63199999 48.89599999 0 26.88 20.48 48.896 45.63200001 48.896z m3.26399999-219.904l795.776 0c26.88 0 50.56-20.352 51.328-47.16800001A48.896 48.896 0 0 0 911.10399999 128L115.328 128c-26.88 0-50.56 20.41600001-51.328 47.16800001a48.896 48.896 0 0 0 48.89600001 50.56z m619.776 447.232L732.672 348.672 960 510.78399999l-227.328 162.11200001c0 0.768 0 0.768 0 0z m178.432 122.94400001L115.328 795.84000001c-26.88 0-50.56 20.48-51.328 47.23199998a48.896 48.896 0 0 0 48.89600001 50.49600001l795.77599999 0c26.88 0 50.56-20.41600001 51.328-47.232a48.896 48.896 0 0 0-48.89600001-50.49600001z"
              p-id="7122"></path>
          </svg>
        </div>

        <div class="admin-shell__status">
          <span class="admin-shell__status-dot" :class="`is-${statusState}`"></span>
          <span>{{ statusText }}</span>
        </div>

        <AdminUserMenu :display-name="displayName" @logout="logout" />
      </header>

      <main class="admin-shell__content">
        <section v-if="!hideHero" class="admin-shell__hero">
          <div>
            <h1 class="admin-shell__title">{{ pageTitle }}</h1>
            <p v-if="pageSubtitle" class="admin-shell__subtitle">{{ pageSubtitle }}</p>
          </div>
          <div v-if="$slots.actions" class="admin-shell__actions">
            <slot name="actions" />
          </div>
        </section>

        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/api'
import { removeToken } from '@/utils/auth'
import AdminSidebar from './AdminSidebar.vue'
import AdminUserMenu from './AdminUserMenu.vue'

function resolveDisplayName(data = {}) {
  const source = data?.commercial && typeof data.commercial === 'object'
    ? { ...data.commercial, ...data }
    : data

  return (
    source.username ||
    source.user_name ||
    source.account ||
    source.mobile ||
    source.loginName ||
    '未登录用户'
  )
}

export default {
  name: 'AdminShell',
  components: {
    AdminSidebar,
    AdminUserMenu,
  },
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
    pageSubtitle: {
      type: String,
      default: '',
    },
    activeMenu: {
      type: String,
      default: 'home',
    },
    statusText: {
      type: String,
      default: '系统运行正常',
    },
    statusState: {
      type: String,
      default: 'success',
      validator(value) {
        return ['success', 'warning', 'danger'].includes(value)
      },
    },
    hideHero: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayName: '未登录用户',
      commercialId: '',
      mobileOpen: false,
      sidebarCollapsed: false,
      isMobileViewport: false,
    }
  },
  mounted() {
    this.restoreSidebarState()
    this.handleViewportChange()
    window.addEventListener('resize', this.handleViewportChange)
    this.loadUserInfo()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleViewportChange)
  },
  methods: {
    restoreSidebarState() {
      try {
        this.sidebarCollapsed = localStorage.getItem('admin_sidebar_collapsed') === '1'
      } catch (_) {
        this.sidebarCollapsed = false
      }
    },
    handleViewportChange() {
      this.isMobileViewport = window.innerWidth <= 768
      if (this.isMobileViewport) {
        this.mobileOpen = false
      }
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
      try {
        localStorage.setItem('admin_sidebar_collapsed', this.sidebarCollapsed ? '1' : '0')
      } catch (_) { }
    },
    async loadUserInfo() {
      try {
        const { data } = await getUserInfo()
        this.displayName = resolveDisplayName(data)
        this.commercialId = String(
          data?.commercial_id
          || (data?.commercial && (data.commercial.id || data.commercial.commercial_id))
          || data?.id
          || ''
        )
      } catch (error) {
        this.displayName = '未登录用户'
        this.commercialId = ''
      }
    },
    logout() {
      this.$store.commit('SET_TOKEN', '')
      localStorage.removeItem('lvtu_live_apitoken')
      removeToken()
      this.$router.push('/signin')
    },
  },
}
</script>

<style scoped>
.admin-shell {
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(50, 96, 224, 0.09), transparent 24%),
    linear-gradient(180deg, #f6f8fc 0%, #eef2f8 100%);
}

.admin-shell__overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  background: rgba(15, 23, 42, 0.38);
}

.admin-shell__main {
  min-height: 100vh;
  margin-left: 320px;
  transition: margin-left 0.2s ease;
}

.admin-shell__main.is-collapsed {
  margin-left: 96px;
}

.admin-shell__topbar {
  min-height: 104px;
  padding: 30px 40px 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 18px;
}

.admin-shell__menu-button {
  display: none;
  width: 44px;
  height: 44px;
  margin-right: auto;
  border: 1px solid #d9e0ee;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
}

.admin-shell__collapse-button {
  width: 30px;
  height: 30px;
  margin-right: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  /* background: #fff; */
  cursor: pointer;
}

.admin-shell__collapse-button span {
  width: 16px;
  height: 16px;
  display: inline-block;
  border-top: 2px solid #0f172a;
  border-right: 2px solid #0f172a;
  transform: rotate(225deg);
  transition: transform 0.2s ease;
}

.admin-shell__collapse-button span.is-collapsed {
  transform: rotate(45deg);
}

.admin-shell__menu-button span {
  display: block;
  width: 18px;
  height: 2px;
  margin: 4px auto;
  border-radius: 999px;
  background: #0f172a;
}

.admin-shell__status {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #60749c;
  font-size: 14px;
}

.admin-shell__status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c55e;
}

.admin-shell__status-dot.is-warning {
  background: #f59e0b;
}

.admin-shell__status-dot.is-danger {
  background: #ef4444;
}

.admin-shell__content {
  padding: 18px 40px 40px;
}

.admin-shell__hero {
  margin-bottom: 28px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.admin-shell__title {
  margin: 0;
  color: #0f1d3d;
  font-size: 42px;
  line-height: 1.1;
  font-weight: 800;
}

.admin-shell__subtitle {
  margin: 12px 0 0;
  color: #6a7a98;
  font-size: 16px;
  line-height: 1.7;
}

.admin-shell__actions {
  flex-shrink: 0;
}

@media (max-width: 1024px) {
  .admin-shell__topbar {
    padding-left: 24px;
    padding-right: 24px;
  }

  .admin-shell__content {
    padding-left: 24px;
    padding-right: 24px;
  }
}

@media (max-width: 768px) {
  .admin-shell__main {
    margin-left: 0;
  }

  .admin-shell__topbar {
    min-height: 80px;
    padding-top: 16px;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .admin-shell__menu-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .admin-shell__collapse-button {
    display: none;
  }

  .admin-shell__status {
    order: 3;
    width: 100%;
    margin-top: -4px;
  }

  .admin-shell__content {
    padding: 12px 16px 28px;
  }

  .admin-shell__hero {
    margin-bottom: 22px;
    flex-direction: column;
  }

  .admin-shell__title {
    font-size: 30px;
  }

  .admin-shell__subtitle {
    margin-top: 8px;
    font-size: 14px;
  }

  .admin-shell__actions {
    width: 100%;
  }
}
</style>
